import { ColDef } from 'ag-grid-community';

export class AppScopeMapperGridColumnsModel {
	/**
	 * Return columns configuration.
	 * @param acuities
	 */
	getColumns(acuities: Array<any>, cmpAacuities: Array<any>): Array<ColDef> {
		return [
			{
				headerName: 'AppScope',
				field: 'scopeName',
				width: 120,
				resizable: true
			},
			{
				headerName: 'Acuity',
				width: 120,
				cellRenderer: 'selectListCellRenderer',
				cellRendererParams: {listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName'}
			},
			{
				headerName: 'Cmp Acuity',
				width: 120,
				cellRenderer: 'selectListCellRenderer',
				cellRendererParams: {listItems: cmpAacuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
			}
		];
	}
}
